export function register({ getState }) {
  window.web3dTool = {
    getState
  };
}
